(function($, _) {
  var ns = window.nspace("ccc.viz.shared.views");

  /**
   * Shows a spinner while waiting for asynchronous server communications to complete
   */
  ns.LoadingSpinnerView = Backbone.View.extend({
    el: "#loading-spinner",

    initialize: function(options) {
      if (!options.dispatcher) {
        throw "The loading spinner view requires an event dispatcher.";
      }

      _.bindAll(this, "render", "addTask", "endTask", "endAllTasks");

      this.loadingTasks = [];

      this.dispatcher = options.dispatcher;
      this.dispatcher.on("add-task", this.addTask);
      this.dispatcher.on("end-task", this.endTask);
      this.dispatcher.on("end-all-tasks", this.endAllTasks);
    },

    /**
     * Adds a new loading task to display
     */
    addTask: function(args) {
      var text = args.text;
      var name = args.name;

      if (typeof text === "undefined") {
        text = "Loading...";
      }

      this.loadingTasks.push({
        name: name,
        text: text
      });

      this.render();
    },

    /**
     * Removes a loading task
     */
    endTask: function(args) {
      var name = args.name;

      for (var i = 0; i < this.loadingTasks.length; i++) {
        if (this.loadingTasks[i].name === name) {
          this.loadingTasks.splice(i, 1);
          break;
        }
      }

      this.render();
    },

    /**
     * Removes all loading tasks matching the taskName
     */
    endAllTasks: function(args) {
      var name = args.name;

      for (var i = 0; i < this.loadingTasks.length; i++) {
        if (this.loadingTasks[i].name === name) {
          this.loadingTasks.splice(i, 1);
          i--; // adjust the index since we just removed an item
        }
      }

      this.render();
    },

    render: function() {
      // Hide the spinner if there are no pending tasks
      if (this.loadingTasks.length === 0) {
        this.$el.fadeOut();
        return;
      }

      // Otherwise, show the next task in the queue
      var task = this.loadingTasks[0];
      this.$el.stop(true).css("display", "inherit");
      $("span", this.$el).text(task.text);
    }
  });
})(jQuery, _);
